import { render, staticRenderFns } from "./BalanceHistoryFilter.vue?vue&type=template&id=3896cf53&scoped=true"
import script from "./BalanceHistoryFilter.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896cf53",
  null
  
)

export default component.exports